import React from "react";
import ProfileTitle from "../../components/ProfileTitle";
import Styles from "../platform-pages/admin/sys-site/site.module.css";
import {Button, Form, Input, message} from "antd";
import {useRequest} from "ahooks";
import * as api from "../../apis/apiConfig";


function D365Config() {

    const [form] = Form.useForm()

    useRequest(api.getApiConfiguration, {
        defaultParams: ['d365'],
        onSuccess: response => {
            form.setFieldsValue(response.data.data)
        }
    })

    const {run, loading} = useRequest(api.modifyApiConfiguration, {
        manual: true,
        onSuccess: () => {
            message.success("保存成功")
        }
    })

    return (
        <div>
            <ProfileTitle>站点配置</ProfileTitle>
            <div className={Styles.container}>
                <Form form={form} layout={"vertical"} style={{width: 300}} onFinish={values => run('d365', values)}>
                    <Form.Item label={'接口地址'} name={'resource'}
                               rules={[{required: true, message: '请输入接口地址'}]}>
                        <Input/>
                    </Form.Item>
                    <Form.Item label={'客户端编号'} name={'clientId'}
                               rules={[{required: true, message: '请输入客户端编号'}]}>
                        <Input/>
                    </Form.Item>
                    <Form.Item label={'客户端密钥'} name={'clientSecret'}
                               rules={[{required: true, message: '请输入客户端密钥'}]}>
                        <Input/>
                    </Form.Item>
                    <Form.Item label={'授权地址'} name={'authority'}
                               rules={[{required: true, message: '请输入授权地址'}]}>
                        <Input/>
                    </Form.Item>
                    <div style={{textAlign: "center"}}>
                        <Button type={"primary"} loading={loading} htmlType={'submit'}>保存</Button>
                    </div>
                </Form>
            </div>
        </div>
    )
}

export default D365Config
